import React from 'react';
import { connect } from "react-redux";
import $ from "jquery";
import {hashHistory} from "react-router";

import {getQtCategories} from "../../api/server-api";
import DesktopHeader from "../desktopHeader";
import {setInitialFlowAdditionalRooms, setInitialFlowStep} from "../../actions/initialFlowFunctions";
import {loaderDisable, loaderEnable} from "../ui/loaderView";
import InitialFlowFooterQuestion from "./initialFlowFooterQuestion";
import ProjectScopeMobileHeader from "../projectScope/projectScopeMobileHeader";
import {AVAILABLE_VISUALIZERS} from "../../config";
import {s3FeatureImagePath} from "../../misc/utils";

class InitialFlow extends React.Component {

  state = {
    render: false
  };

  componentDidMount() {
    document.body.classList.add('body--apply-popup');
    if (this.props.fabricatorData.received) {
      this.setState({
        render: true
      })
    } else {
      this.setQtCategoriesRooms();
    }
    this._isMounted = true;
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.fabricatorData.received && !this.props.fabricatorData.received) {
      if (nextProps.fabricatorData.settings.visualizerOnly) {
        hashHistory.push("/visualizer");
      }
    }
  }

  componentWillUnmount() {
    document.body.classList.remove('body--apply-popup');
    this._isMounted = false;
  }

  setQtCategoriesRooms = async () => {
    loaderEnable();
    // await getFabricatorSubscriptions();  // we receive it in the main index file
    const response = await getQtCategories();
    // console.log("qtCategories", response);
    let initialFlowAdditionalRooms = [];
    response.forEach(qtCategory => {
      qtCategory.featureGroups.forEach(featureGroup => {
        if (featureGroup.groupName === "Room") {
          featureGroup.features.forEach(dbFeature => {
            const roomKey = dbFeature.displayName.replace("Room - ", "");
            if (roomKey !== AVAILABLE_VISUALIZERS.Kitchen && roomKey !== AVAILABLE_VISUALIZERS.Bathroom) {
              initialFlowAdditionalRooms.push({
                roomKey,
                thumbnail: s3FeatureImagePath(dbFeature)
              });
            }
          });
        }
      })
    });
    this.props.setInitialFlowAdditionalRooms(initialFlowAdditionalRooms);
    loaderDisable();
    if (this._isMounted) {
      this.setState({
        render: true
      })
    }
  };

  handleFooterBackClick = () => {
    if (this.props.initialFlowStep === 1) {
      $(".flow-room, .flow-footer").fadeOut(300, () => {
        hashHistory.push("/wizard");
      });
    } else {
      $(".flow-layouts").fadeOut(300, () => {
        hashHistory.push("/wizard/room");
      });
    }
  };

  render() {
    return this.state.render ? (
      <div className={"flow"}>
        {this.props.windowWidth < 991 ? <ProjectScopeMobileHeader/> : <DesktopHeader uploadsAndNotes={false}/>}
        <div className={"flow-content flow-content--"+this.props.initialFlowStep}>
          {this.props.children}
        </div>
        <div className="flow-footer">
          <InitialFlowFooterQuestion/>
          <div className="flow-footer__buttons">
            <button className="selection-footer-buttons__button selection-footer-buttons__button--prev"
                    onClick={this.handleFooterBackClick}>
              Back
            </button>
          </div>
        </div>
      </div>
    ) : null
  }
}

const mapStateToProps = (store) => {
  return {
    initialFlowStep: store.initialFlowState.initialFlowStep,
    windowWidth: store.serverState.windowWidth,
    fabricatorData: store.fabricatorState,
  };
};

export default connect(mapStateToProps, {
  setInitialFlowAdditionalRooms,
  setInitialFlowStep
})(InitialFlow);
